import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API, setToken, formatApiError } from "@/lib/api";
import { BRAND } from "@/lib/brand";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.access_token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 bg-[#F4F4ED]">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-white border border-[#004225]/10 rounded-sm p-8 shadow-sm">
        <div className="flex flex-col items-center text-center">
          <img src={BRAND.logo} alt="GN Agro Traders" className="h-16 w-16" />
          <div className="mt-3 font-display text-2xl text-[#004225]">Admin Console</div>
          <div className="text-[11px] font-eyebrow text-[#B5942D]">Restricted Access</div>
        </div>
        <div className="mt-6 space-y-4">
          <div>
            <Label>Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required autoComplete="username" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required autoComplete="current-password" />
          </div>
          {error && <div className="text-[13px] text-red-600" data-testid="admin-login-error">{error}</div>}
          <Button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full btn-primary rounded-full uppercase tracking-widest text-[11px]">
            <Lock className="h-3.5 w-3.5 mr-2" />{busy ? "Signing in…" : "Sign In"}
          </Button>
          <div className="text-center"><Link to="/" className="text-[12px] text-[#171717]/60 hover:text-[#004225]">← Back to website</Link></div>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
